import { AccountStatus, OnboardingStatus } from "../../hooks/useWhoAmI";

/**
 * Helper function to check account status
 */
export const checkAccountStatus = (data: any): AccountStatus | null => {
	if (!data) return null;
	const status = data.account_status;
	if (status && Object.values(AccountStatus).includes(status)) {
		return status as AccountStatus;
	}
	return null;
};

/**
 * Helper function to check onboarding status
 */
export const checkOnboardingStatus = (data: any): OnboardingStatus | null => {
	if (!data) return null;
	const status = data.onboarding_status;
	if (status && Object.values(OnboardingStatus).includes(status)) {
		return status as OnboardingStatus;
	}
	return null;
};

/**
 * Helper function to get redirect path with query params based on account and onboarding status
 */
export const getRedirectPath = (
	accountStatus: AccountStatus,
	onboardingStatus: OnboardingStatus | null,
	preservedQueryString: string,
): string | null => {
	const params = new URLSearchParams(preservedQueryString);
	
	let path: string | null = null;

	// Case 1: account_status=active && onboarding_status=completed -> Profile Page
	if (accountStatus === AccountStatus.ACTIVE && onboardingStatus === OnboardingStatus.COMPLETED) {
		path = "/profile";
	}
	// Case 2: account_status=under_review && onboarding_status=completed -> Waitlist
	else if (accountStatus === AccountStatus.UNDER_REVIEW && onboardingStatus === OnboardingStatus.COMPLETED) {
		path = "/agent/waitlist";
	}
	// Case 3: account_status=under_review && onboarding_status=processing -> Waitlist
	else if (accountStatus === AccountStatus.UNDER_REVIEW && onboardingStatus === OnboardingStatus.PROCESSING) {
		path = "/agent/waitlist";
	}
	// Case 3b: account_status=active && onboarding_status=processing -> Waitlist
	else if (accountStatus === AccountStatus.ACTIVE && onboardingStatus === OnboardingStatus.PROCESSING) {
		path = "/agent/waitlist";
	}
	// Case 4: account_status=active && onboarding_status=pending -> Agent Page
	else if (accountStatus === AccountStatus.ACTIVE && onboardingStatus === OnboardingStatus.PENDING) {
		path = "/agent";
	}
	// Case 5: account_status=active && onboarding_status=onboarding -> Onboarding Page
	else if (accountStatus === AccountStatus.ACTIVE && onboardingStatus === OnboardingStatus.ONBOARDING) {
		path = "/onboarding";
	}
	// Fallback: If account_status is not active, redirect to waitlist
	else if (accountStatus !== AccountStatus.ACTIVE) {
		path = "/agent/waitlist";
	}
	// Fallback: If account_status is active but no matching onboarding_status, redirect to profile
	else if (accountStatus === AccountStatus.ACTIVE) {
		path = "/profile";
	}

	if (!path) {
		return null;
	}

	// Return path with query string
	const queryString = params.toString();
	return queryString ? `${path}?${queryString}` : path;
};

